<template>
  <div>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitSystem)">
        <b-card>
          <b-card-title> {{ system.name }} System </b-card-title>
          <UploadImage
            :imageUrl="system.dashboardImageUrl"
            @url="urlUploaded"
          />
        </b-card>
        <b-card>
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <base-input
                    v-model="system.name"
                    rules="required"
                    name="Name"
                    label="Name"
                  ></base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <base-input
                    v-model="system.domain"
                    name="Domain"
                    rules="required"
                    label="Domain"
                  ></base-input>
                </b-col>
                <b-col>
                  <base-input
                    v-model="system.url"
                    label="Url"
                    name="Url"
                    prependChar="https://"
                  ></base-input>
                </b-col>
                <b-col>
                  <base-input
                    v-model="system.supportUrl"
                    label="Support Url"
                    name="Support Url"
                    rules="required"
                    prependChar="https://"
                  ></base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <base-input
                    name="e-mail "
                    v-model="system.email"
                    rules="required|email"
                    label="E-Mail address"
                  ></base-input>
                </b-col>
                <b-col>
                  <base-input-phone
                    rules="required"
                    name="Phone Number"
                    v-model="system.phoneNumber"
                    label="Phone Number"
                  ></base-input-phone>
                </b-col>
              </b-row> </b-col
            ><b-col>
              <h2>Roles</h2>
              {{ roles }}
              <Role
                :availableRoles="availableRoles"
                :roles="system.roles"
                @rolesUpdated="rolesUpdated"
              /> </b-col
          ></b-row>
          <a href="/#/admin/systems" class="btn btn-danger" variant="danger"
            >Cancel</a
          >
          <b-button type="submit" variant="primary">Update System</b-button>
        </b-card>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import UploadImage from "@/views/Components/UploadImage.vue";
import Role from "@/views/Components/User/Role.vue";
export default {
  components: { UploadImage, Role },
  data() {
    return {
      system: null,
      file: null,
      availableRoles: null,

      id: null,
    };
  },
  async created() {
    this.id = this.$route.params.id;

    let r = await this.$client.get("/api/roles/getAllRoles");

    this.availableRoles = r.data.value;

    if (this.id) {
      let r = await this.$client.get("/api/system/getSystem?id=" + this.id);
      if (r.data.isSuccess) {
        this.system = r.data.value.system;
      }
    } else {
      this.system = {
        id: null,
        name: "",
        domain: "",
        url: "",
        email: "",
        roles: [],
        phoneNumber: "",
      };
    }
  },
  methods: {
    rolesUpdated(roles) {
      this.system.roles = JSON.parse(JSON.stringify(roles));
    },
    urlUploaded(urlUploaded) {
      this.system.dashboardImageUrl = urlUploaded;
      if (this.system.id && urlUploaded != null) {
        this.submitSystem();
      }
    },
    async submitSystem() {
      if (this.system.dashboardImageUrl == null) {
        this.$emitter.emit("error", "You must upload an image");
        return;
      }

      let r = await this.$client.post("/api/system/upsertSystem", this.system);

      if (r.data.isSuccess) {
        this.$emitter.emit("success", { message: "System Updated" });
        location.href = "/#/admin/system";
      }
    },
  },
};
</script>

<style></style>
